<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="currentColor"
    x="0px"
    y="0px"
    viewBox="0 0 25 26"
    enable-background="new 0 0 25 26"
    xml:space="preserve"
  >
    <g>
      <path
        fill="#6A6A6A"
        d="M19.955,14.755v7.068c0,0.051-0.043,0.096-0.096,0.096H5.142c-0.053,0-0.096-0.045-0.096-0.096v-7.125
		l-2.553-1.701v8.826c0,1.457,1.188,2.646,2.648,2.646h14.717c1.459,0,2.646-1.189,2.646-2.646V13.05L19.955,14.755z"
      />
      <path
        fill="#209AD6"
        d="M23.568,2.132c-0.199-0.371-0.586-0.602-1.01-0.602c-0.188,0-0.373,0.047-0.541,0.137l-9.57,5.148
		L2.98,1.739C2.814,1.651,2.628,1.604,2.441,1.604c-0.424,0-0.811,0.23-1.01,0.604C1.136,2.757,1.339,3.444,1.882,3.747l9.994,6.67
		l0.029,0.018c0.166,0.088,0.352,0.137,0.541,0.137s0.377-0.049,0.543-0.139l10.129-6.76C23.662,3.37,23.865,2.683,23.568,2.132z"
      />
      <path
        fill="#7FB942"
        d="M23.568,8.403c-0.199-0.371-0.586-0.602-1.01-0.602c-0.188,0-0.373,0.047-0.541,0.137l-9.57,5.148
		L2.98,8.011C2.814,7.923,2.626,7.876,2.441,7.876c-0.424,0-0.811,0.23-1.01,0.604c-0.145,0.27-0.176,0.578-0.086,0.871
		c0.086,0.287,0.275,0.523,0.537,0.668l9.994,6.67l0.029,0.018c0.166,0.09,0.352,0.137,0.541,0.137s0.377-0.049,0.541-0.139
		l10.131-6.76C23.662,9.642,23.865,8.954,23.568,8.403z"
      />
    </g>
  </svg>
</template>
